@defer (on idle) {
  @if (apiReady()) {
    @if (isLoggedIn()) {
      <!-- Internal Structure -->

      <div id="internal-skeleton" class="bg-emphasis rounded-lg m-2 items-start">
        <div id="menu-wrapper" [style.left]="menuOpen() ? '0' : ''">
          <div id="menu-header" class="flex flex-row p-2 mb-5">
            <span class="text-xl font-bold mr-auto p-1">{{
              'internal.menu.title' | translate
            }}</span>
            <p-button [rounded]="true" [text]="true" (click)="closeMenu()">
              <mat-icon>close</mat-icon>
            </p-button>
          </div>

          <div class="flex flex-col overflow-auto" [style.height]="'calc(100% - 52px)'">
            <!-- <div class="w-auto ml-5 mr-5 bg-surface-900 h-0.5"></div> -->
            @for (linkgroup of filteredMenuEntries | keyvalue; track $index; let isLast = $last) {
              @if (linkgroup.key != '') {
                <div class="menu-subheader font-bold mb-4">
                  {{ 'internal.menu.linkgroups.' + linkgroup.key | translate }}
                </div>
              }

              @for (link of linkgroup.value; track $index) {
                <div
                  class="menu-item h-10 min-h-10 flex flex-row items-center"
                  [class.disabled]="link.disabled"
                  [routerLink]="link.disabled ? '' : link.route"
                  routerLinkActive="active"
                  #rla="routerLinkActive"
                  (click)="link.disabled ? undefined : closeMenu()"
                >
                  @if (rla.isActive && !link.disabled) {
                    <div class="w-1.5 h-full bg-primary-400"></div>
                  }

                  <mat-icon
                    iconClass="ml-2"
                    [iconStyle]="
                      'margin-left: ' + (rla.isActive && !link.disabled ? '12px' : '18px')
                    "
                    >{{ link.icon }}</mat-icon
                  >

                  <span class="text-base font-normal ml-4">{{ link.label | translate }}</span>
                  @if (rla.isActive && !link.disabled) {
                    <div class="w-1.5 h-full bg-primary-400 ml-auto"></div>
                  }
                </div>
              }
              @if (!isLast) {
                <div class="w-auto ml-5 mr-5 bg-surface-900 h-0.5 min-h-0.5 mt-8 mb-8"></div>
              } @else {
                <div class="w-auto mb-auto"></div>
              }
            }

            <div class="w-auto ml-5 mr-5 bg-surface-900 h-0.5 min-h-0.5 mt-2 mb-2"></div>
            <div class="menu-item h-10 min-h-10 flex flex-row items-center mb-2" (click)="logout()">
              <mat-icon iconClass="ml-2" [iconStyle]="'margin-left: 18px'">logout</mat-icon>
              <span class="text-base font-normal ml-4">{{ 'general.logout' | translate }}</span>
            </div>
          </div>
        </div>

        @if (shadowVisible()) {
          <div
            id="contentClickHandler"
            [style.opacity]="menuOpen() ? '1' : '0'"
            (click)="closeMenu()"
          ></div>
        }

        <div id="content" class="overflow-auto w-full h-full max-w-full bg-neutral-900">
          <router-outlet />
        </div>
      </div>
    } @else {
      <!-- Login Form -->

      <div id="internal-login-box" class="bg-emphasis rounded-lg p-5">
        <p-fluid>
          <h2 class="text-2xl text-center">{{ 'general.login.title' | translate }}</h2>

          <form (submit)="login()" [formGroup]="loginForm">
            <p-floatlabel variant="on" class="mt-10">
              <input
                pInputText
                id="formfield-username"
                formControlName="username"
                [invalid]="
                  loginForm.controls.username.invalid && loginForm.controls.username.touched
                "
                autocomplete="off"
                required
              />
              <label for="formfield-username">{{ 'general.login.username' | translate }}</label>
            </p-floatlabel>

            <p-floatlabel variant="on" class="mt-5 mb-10">
              <p-password
                id="formfield-password"
                formControlName="password"
                [invalid]="
                  loginForm.controls.password.invalid && loginForm.controls.password.touched
                "
                [feedback]="false"
                autocomplete="off"
                required
              />
              <label for="formfield-password">{{ 'general.login.password' | translate }}</label>
            </p-floatlabel>

            @if (loginError()) {
              <p-message severity="error" class="mb-10">{{ loginError() | translate }}</p-message>
            }

            <p-button
              type="submit"
              [label]="'general.login.button' | translate"
              [disabled]="!loginForm.valid"
              [loading]="loggingIn()"
            />
            <!--!profileForm.valid-->
          </form>
        </p-fluid>
      </div>
    }
  } @else {
    <!-- Login Form Shell with Loading Spinner -->
    <div id="internal-login-box" class="bg-emphasis rounded-lg p-5" style="height: 298px">
      <h2 class="text-2xl text-center">{{ 'general.login.title' | translate }}</h2>

      <div class="flex items-center h-full">
        <p-progress-spinner [ariaLabel]="'general.loading' | translate" />
      </div>
    </div>
  }
} @placeholder {
  <!-- Login Form Shell -->
  <div id="internal-login-box" class="bg-emphasis rounded-lg p-5" style="height: 298px"></div>
}
